import { FC } from 'react';
import { Form } from 'react-final-form';
import { Button, Drawer, FormElement, Label } from '@smart-kasa/ui';

import { Field, RangePicker } from 'components';
import { dateToISO8601String } from 'utils/date';
import { useShops, ShopSelectField } from 'features/shops';

export interface IStockFilterForm {
  show: boolean;
  initialValues: any;
  onClose: () => void;
  onSubmit: (values) => void;
}

export const StockFilterForm: FC<IStockFilterForm> = ({
  initialValues,
  onSubmit,
  onClose,
  ...rest
}) => {
  const { shops } = useShops();

  const handleSubmit = (fd) => {
    onSubmit(fd);
    onClose();
  };

  return (
    <Form onSubmit={handleSubmit} initialValues={initialValues}>
      {({ handleSubmit, form, values }) => (
        <Drawer
          onClose={onClose}
          title="Фільтр"
          footer={
            <Button onClick={handleSubmit} width="full" color="primary">
              Застосувати
            </Button>
          }
          {...rest}
        >
          <FormElement label={<Label>Переглянути за датою</Label>}>
            <RangePicker
              from={values.dateStart}
              to={values.dateEnd}
              onChangeDateStart={(date) => form.change('dateStart', dateToISO8601String(date))}
              onChangeDateEnd={(date) => form.change('dateEnd', dateToISO8601String(date))}
            />
          </FormElement>

          <ShopSelectField
            name="shopId"
            label="Торгова точка"
            placeholder="Оберіть торгову точку"
            options={shops}
            value={Number(values.shopId)}
          />

          <Field.Input name="q" label="Пошук" placeholder="Введіть текст" />
        </Drawer>
      )}
    </Form>
  );
};
